// export const dateTimeFormats = {
//   MMMDDYYhhmmssa: 'MMM D, YYYY h:mma',
//   MMMDDYY: 'MMM D, YYYY',
//   HMMAMMMD: 'h:mma MMM, D',
//   MMMDYY: 'MMM, D YY',
//   MMMDYYYY: 'MMM D, YYYY',
// };
export const datetimeFormat = {
  dddmmmyy: 'D, MMM YY',
  listD: 'MMM D, YYYY',
  yyyymmmdd: 'YYYY-MMM-DD',
  listDT: 'MMM D, YYYY h:mm a',
  exportFormatD: 'YYYY/MM/DD',
  exportFormatDT: 'YYYY/MM/DD h:mma',
  mmmddyyyy: 'MMM DD, YYYY',
  mmmmddyyyy: 'MMMM DD, YYYY',
  mmmdhhmma: 'MMM D h:mm a',
  mmmmdhhmma: 'MMMM D h:mm a',
  mmmdchhmma: 'MMM D  -  h:mm a',
  mmmdyyyy: 'MMM D, YYYY',
  mmmmdyyyy: 'MMMM D, YYYY',
  mmmdyy: 'MMM D, YY',
  mmmdyyhhmmaa: 'MMM D, YYYY h:mma',
  mmmmdyyhhmmaa: 'MMMM D, YYYY h:mma',
  hhmmaammmdyy: 'h:mma MMM D, YYYY',
  dddmmmdyy: 'ddd MMM DD, YYYY',
  dddmmmmdyy: 'ddd MMMM DD, YYYY',
  dmmmyy: 'DD-MMM-YY',
  mmmyyyy: 'MMM YYYY',
  mmmmyyyy: 'MMMM YYYY',
  yyyymmddhhmm:'YYYY-MMM-DD-hh-mm',
  yyymmdd: 'YYYY-MM-DD',
  ddmmyyyy: 'DD-MM-YYYY',
  hmma: 'h:mma',
  hhmm: 'HH:mm',
  Hmm: 'H:mm',
  hhmma: 'hh:mma',
  hhmmA: 'hh:mm A',
  dddddmmm: 'DDD, DD MMM',
  ddd: 'ddd',
  d: 'D',
  mm: 'mm',
  hh: 'HH',
  dddd: 'dddd',
  hhmmss: 'hh:mm:ss',
  hhmmammmdd: 'h:mma MMM D',
  yyymmddhhmm: 'YYYY-MM-DD HH:mm',
  hmmammmd: 'h:mma MMM, D',
  mmddyyyy: 'MM-DD-YY',
  mmmdyh: 'MMM d, y, h:mm a',
};
